export default {
  // 页面标题
  title: "自动推送配置",

  // 搜索表单
  searchForm: {
    pushTitle: "推送标题",
    pushTitlePlaceholder: "请输入",
    language: "语言",
    languagePlaceholder: "请选择",
    pushSwitch: "推送开关",
    pushSwitchPlaceholder: "请选择",
    search: "查询",
    reset: "重置",
    add: "新增"
  },

  // 表格列标题
  table: {
    pushType: "推送类型",
    subType: "子类型",
    pushTitle: "推送标题",
    pushContent: "推送内容",
    jumpPath: "跳转路径",
    language: "语言",
    pushSwitch: "推送开关",
    inboxPushSwitch: "站内消息开关",
    inboxMessageType: "站内消息类型",
    operation: "操作",
    edit: "修改",
    delete: "删除"
  },

  // 推送类型
  pushTypes: {
    recharge: "充值",
    withdrawal: "提现",
    vipReward: "VIP奖励",
    activityOffer: "活动优惠",
    kyc: "KYC"
  },

  // 子类型
  subTypes: {
    onlineRecharge: "线上充值",
    manualRecharge: "人工充值",
    onlineWithdrawal: "线上提现",
    manualWithdrawal: "人工提现",
    upgradeBonus: "升级礼金",
    retentionBonus: "保级礼金",
    weeklySalary: "周俸禄",
    monthlySalary: "月俸禄",
    birthdayBonus: "生日礼金",
    kycVerification: "KYC认证",
    manualRechargePoints: "人工充值积分",
    manualDeductPoints: "人工扣减积分",
    upgradePoints: "升级积分",
    retentionPoints: "保级积分",
    h5DailyPoints: "h5每日积分",
    appDailyPoints: "app每日积分",
    bettingRebate: "投注返水",
    realtimeRebate: "时时返水",
    registrationOffer: "注册优惠",
    dailyFirstDeposit: "每日首充",
    rechargeOffer: "充值优惠",
    manualIssue: "手动发放",
    everyDepositOffer: "笔笔存优惠",
    firstDepositOffer: "首存优惠"
  },

  // 推送开关状态
  pushSwitch: {
    enabled: "开启",
    disabled: "关闭"
  },

  // 弹窗
  modal: {
    addTitle: "新增",
    editTitle: "编辑",
    pushType: "推送类型",
    pushTypePlaceholder: "请选择",
    subType: "子类型",
    subTypePlaceholder: "请选择",
    notificationTitle: "通知标题",
    notificationTitlePlaceholder: "50个字符以内",
    memberType: "会员类型",
    memberTypePlaceholder: "请选择会员类型",
    loginChannel: "登录终端",
    loginChannelPlaceholder: "请选择",
    notificationContent: "通知内容",
    notificationContenttips: ' （推送内容如涉及到金额或其他变量，请用{0} 格式添加）',
    notificationContentPlaceholder: "1000个字符以内",
    selectLanguage: "选择语言",
    languagePlaceholder: "请选择",
    jumpPath: "跳转路径",
    jumpPathPlaceholder: "请输入跳转路径",
    pushSwitch: "推送开关",
    inboxPushSwitch: "站内消息推送开关",
    inboxMessageType: "站内消息类型",
    inboxMessageTypePlaceholder: "请选择站内消息类型",
    enable: "开启",
    disable: "关闭",
    confirm: "确定",
    cancel: "取消"
  },

  // 验证消息
  validation: {
    pushTypeRequired: "请选择推送类型",
    subTypeRequired: "请选择子类型",
    notificationTitleRequired: "请输入通知标题",
    notificationContentRequired: "请输入通知内容",
    notificationContentPattern: "推送内容必须包含 {0-9} 格式",
    languageRequired: "请选择语言",
    inboxMessageTypeRequired: "请选择站内消息类型"
  },

  // 定时发送（全体会员，配合 dev 的每日定时循环配置）
  schedule: {
    title: "定时发送设置",
    sendDate: "自动发送日期",
    sendDateRequired: "请选择自动发送日期",
    dailyTime: "每日发送时间",
    dailyTimeRequired: "请选择每日发送时间",
    fillWarning: "请填写自动发送日期和每日发送时间"
  },

  // 操作消息
  messages: {
    addSuccess: "添加成功",
    updateSuccess: "更新成功",
    deleteSuccess: "删除成功",
    deleteFailed: "删除失败",
    fetchDataFailed: "获取数据失败",
    confirmDelete: "确认删除",
    confirmDeleteContent: "确定要删除推送配置\"{title}\"吗？"
  }
};
